@if (articles) {
  <gh-hero-stepper>
    @for (article of articles; track article) {
      <cdk-step>
        <div class="container layout-row snippet-hero">
          <div class="summary">
            <div class="layout-column">
              <a class="line-clamp3" [href]="'./'+article.category.slug+'/'+article.slug">
                <h1 [innerHTML]="article.title"></h1>
              </a>
              <div class="layout-row space-between spacer-vr-16">
                <div class="layout-row align-middle">
                  <span class="category-icon small-icon">
                    <img [src]="article.category.marker" [alt]="article.category.slug" width="14px" height="14  px">
                  </span>
                  <a class="spacer-left-8 small" [href]="'./'+article.category.slug">{{article.category.name}}</a>
                </div>
                <span class="layout-row align-middle info text-right txt-navy-light">{{article.publishDate}} ● {{article.readTime}}</span>
              </div>
              <div class="line-clamp4">
                <p class="spacer-top-16">{{article.summary}}</p>
              </div>
            </div>
          </div>
          <a class="image" [href]="'./'+article.category.slug+'/'+article.slug" role="banner" aria-label="link to article">
            <img [src]="article.heroImageUrl" [alt]="article.title" width="100%" height="100%">
          </a>
        </div>
      </cdk-step>
    }
  </gh-hero-stepper>
}
